function applyMeta(routes) {
  return routes.map((route) => ({
    ...route,
    meta: {
      ...(route.meta || {}),
      category: 'soi',
    },
  }));
}

export default applyMeta([
  {
    path: '/Aboutyou',
    name: 'Aboutyou',
    component: () => import('../../components/Aboutyou.vue'),
  },
  {
    path: '/Aboutyou2',
    name: 'Aboutyou2',
    component: () => import('../../components/Aboutyou2.vue'),
  },
  // {
  //   path: '/CashApp',
  //   name: 'CashApp',
  //   component: () => import('../../components/CashApp.vue'),
  // },
  // {
  //   path: '/CashApp1',
  //   name: 'CashApp1',
  //   component: () => import('../../components/CashApp1.vue'),
  // },
  {
    path: '/ALDI',
    name: 'ALDI',
    component: () => import('../../components/ALDI.vue'),
  },
  {
    path: '/ALDI1',
    name: 'ALDI1',
    component: () => import('../../components/ALDI1.vue'),
  },
  {
    path: '/ALDI2',
    name: 'ALDI2',
    component: () => import('../../components/ALDI2.vue'),
  },
  {
    path: '/ALDI3',
    name: 'ALDI3',
    component: () => import('../../components/ALDI3.vue'),
  },
  {
    path: '/ALDI4',
    name: 'ALDI4',
    component: () => import('../../components/ALDI4.vue'),
  },
  {
    path: '/ALDI4_cf',
    name: 'ALDI4_cf',
    component: () => import('../../components/ALDI4_cf.vue'),
  },
  {
    path: '/Amazon',
    name: 'Amazon',
    component: () => import('../../components/Amazon.vue'),
  },
  {
    path: '/Amazon1',
    name: 'Amazon1',
    component: () => import('../../components/Amazon1.vue'),
  },
  {
    path: '/Amazon2',
    name: 'Amazon2',
    component: () => import('../../components/Amazon2.vue'),
  },
  {
    path: '/Amazon3',
    name: 'Amazon3',
    component: () => import('../../components/Amazon3.vue'),
  },
  {
    path: '/Amazon4',
    name: 'Amazon4',
    component: () => import('../../components/Amazon4.vue'),
  },
  {
    path: '/Amazon5',
    name: 'Amazon5',
    component: () => import('../../components/Amazon5.vue'),
  },
  {
    path: '/Amazon6',
    name: 'Amazon6',
    component: () => import('../../components/Amazon6.vue'),
  },
  {
    path: '/Amazon7',
    name: 'Amazon7',
    component: () => import('../../components/Amazon7.vue'),
  },
  {
    path: '/AppleProducts',
    name: 'AppleProducts',
    component: () => import('../../components/AppleProducts.vue'),
  },
  {
    path: '/Adidas',
    name: 'Adidas',
    component: () => import('../../components/Adidas.vue'),
  },
  {
    path: '/Adidas2',
    name: 'Adidas2',
    component: () => import('../../components/Adidas2.vue'),
  },
  {
    path: '/Baby',
    name: 'Baby',
    component: () => import('../../components/Baby.vue'),
  },
  {
    path: '/Bick',
    name: 'Bick',
    component: () => import('../../components/Bick.vue'),
  },
  {
    path: '/Biedronki',
    name: 'Biedronki',
    component: () => import('../../components/Biedronki.vue'),
  },
  {
    path: '/Biedronki1',
    name: 'Biedronki1',
    component: () => import('../../components/Biedronki1.vue'),
  },
  {
    path: '/BurgerKing',
    name: 'BurgerKing',
    component: () => import('../../components/BurgerKing.vue'),
  },
  {
    path: '/BurgerKing_cf',
    name: 'BurgerKing_cf',
    component: () => import('../../components/BurgerKing_cf.vue'),
  },
  {
    path: '/BurgerKing_cf2',
    name: 'BurgerKing_cf2',
    component: () => import('../../components/BurgerKing_cf2.vue'),
  },
  {
    path: '/BurgerKing_cf3',
    name: 'BurgerKing_cf3',
    component: () => import('../../components/BurgerKing_cf3.vue'),
  },

  {
    path: '/BurgerKing2',
    name: 'BurgerKing2',
    component: () => import('../../components/BurgerKing2.vue'),
  },
  {
    path: '/BlackFriday_cf',
    name: 'BlackFriday_cf',
    component: () => import('../../components/BlackFriday_cf.vue'),
  },

  // {
  //   path: '/CashApp2',
  //   name: 'CashApp2',
  //   component: () => import('../../components/CashApp2.vue'),
  // },
  // {
  //   path: '/CashApp3',
  //   name: 'CashApp3',
  //   component: () => import('../../components/CashApp3.vue'),
  // },
  // {
  //   path: '/CashApp4',
  //   name: 'CashApp4',
  //   component: () => import('../../components/CashApp4.vue'),
  // },
  // {
  //   path: '/CashApp5',
  //   name: 'CashApp5',
  //   component: () => import('../../components/CashApp5.vue'),
  // },
  // {
  //   path: '/CashApp6',
  //   name: 'CashApp6',
  //   component: () => import('../../components/CashApp6.vue'),
  // },
  // {
  //   path: '/CashApp7',
  //   name: 'CashApp7',
  //   component: () => import('../../components/CashApp7.vue'),
  // },
  {
    path: '/CashApp9',
    name: 'CashApp9',
    component: () => import('../../components/CashApp9.vue'),
  },
  {
    path: '/CashApp9_cf',
    name: 'CashApp9_cf',
    component: () => import('../../components/CashApp9_cf.vue'),
  },
  {
    path: '/CashApp10',
    name: 'CashApp10',
    component: () => import('../../components/CashApp10.vue'),
  },
  {
    path: '/CashApp10_cf',
    name: 'CashApp10_cf',
    component: () => import('../../components/CashApp10_cf.vue'),
  },
  {
    path: '/CashApp11',
    name: 'CashApp11',
    component: () => import('../../components/CashApp11.vue'),
  },
  {
    path: '/CashApp11_cf',
    name: 'CashApp11_cf',
    component: () => import('../../components/CashApp11_cf.vue'),
  },
  // {
  //   path: '/CashApp8',
  //   name: 'CashApp8',
  //   component: () => import('../../components/CashApp8.vue'),
  // },
  // {
  //   path: '/CashApp12',
  //   name: 'CashApp12',
  //   component: () => import('../../components/CashApp12.vue'),
  // },
  {
    path: '/CashApp12_cf',
    name: 'CashApp12_cf',
    component: () => import('../../components/CashApp12_cf.vue'),
  },
  {
    path: '/CashApp13_cf',
    name: 'CashApp13_cf',
    component: () => import('../../components/Cashapp13_cf.vue'),
  },
  {
    path: '/CashApp14_cf',
    name: 'CashApp14_cf',
    component: () => import('../../components/CashApp14_cf.vue'),
  },
  {
    path: '/CashApp15_cf',
    name: 'CashApp15_cf',
    component: () => import('../../components/CashApp15_cf.vue'),
  },
  {
    path: '/CashApp16_cf',
    name: 'CashApp16_cf',
    component: () => import('../../components/CashApp16_cf.vue'),
  },
  {
    path: '/Christmas',
    name: 'Christmas',
    component: () => import('../../components/Christmas.vue'),
  },
  {
    path: '/Clarks',
    name: 'Clarks',
    component: () => import('../../components/Clarks.vue'),
  },
  {
    path: '/Costco',
    name: 'Costco',
    component: () => import('../../components/Costco.vue'),
  },
  {
    path: '/Costco1',
    name: 'Costco1',
    component: () => import('../../components/Costco1.vue'),
  },
  {
    path: '/Costco2',
    name: 'Costco2',
    component: () => import('../../components/Costco2.vue'),
  },
  {
    path: '/cocaPage',
    name: 'cocaPage',
    component: () => import('../../components/cocaPage.vue'),
  },
  {
    path: '/Cashapporvenmo',
    name: 'Cashapporvenmo',
    component: () => import('../../components/Cashapporvenmo.vue'),
  },
  {
    path: '/Cashapporvenmo_cf',
    name: 'Cashapporvenmo_cf',
    component: () => import('../../components/Cashapporvenmo_cf.vue'),
  },
  {
    path: '/deAmazon',
    name: 'deAmazon',
    component: () => import('../../components/deAmazon.vue'),
  },
  {
    path: '/Ebike',
    name: 'Ebike',
    component: () => import('../../components/Ebike.vue'),
  },
  {
    path: '/ElectricBike',
    name: 'ElectricBike',
    component: () => import('../../components/ElectricBike.vue'),
  },
  {
    path: '/ElectricBike_cf',
    name: 'ElectricBike_cf',
    component: () => import('../../components/ElectricBike_cf.vue'),
  },
  {
    path: '/Elektronisk',
    name: 'Elektronisk',
    component: () => import('../../components/Elektronisk.vue'),
  },
  {
    path: '/FoodStamps',
    name: 'FoodStamps',
    component: () => import('../../components/FoodStamps.vue'),
  },
  {
    path: '/FoodStamps_cf',
    name: 'FoodStamps_cf',
    component: () => import('../../components/FoodStamps_cf.vue'),
  },
  {
    path: '/FoodStamps2_cf',
    name: 'FoodStamps2_cf',
    component: () => import('../../components/FoodStamps2_cf.vue'),
  },
  {
    path: '/Groceries',
    name: 'Groceries',
    component: () => import('../../components/Groceries.vue'),
  },
  {
    path: '/Halloween',
    name: 'Halloween',
    component: () => import('../../components/Halloween.vue'),
  },
  {
    path: '/Hemkop',
    name: 'Hemkop',
    component: () => import('../../components/Hemkop.vue'),
  },
  {
    path: '/IGA',
    name: 'IGA',
    component: () => import('../../components/IGA.vue'),
  },
  {
    path: '/iphone',
    name: 'iphone',
    component: () => import('../../components/iphone.vue'),
  },
  {
    path: '/iphone3',
    name: 'iphone3',
    component: () => import('../../components/iphone3.vue'),
  },
  {
    path: '/Iphone17',
    name: 'Iphone17',
    component: () => import('../../components/Iphone17.vue'),
  },
  {
    path: '/Iphone17promax',
    name: 'Iphone17promax',
    component: () => import('../../components/Iphone17promax.vue'),
  },
  {
    path: '/Ipad',
    name: 'Ipad',
    component: () => import('../../components/Ipad.vue'),
  },
  {
    path: '/Ipad_cf',
    name: 'Ipad_cf',
    component: () => import('../../components/Ipad_cf.vue'),
  },
  {
    path: '/McDonalds',
    name: 'McDonalds',
    component: () => import('../../components/McDonalds.vue'),
  },
  {
    path: '/McDonalds2',
    name: 'McDonalds2',
    component: () => import('../../components/McDonalds2.vue'),
  },
  {
    path: '/McDonalds_cf',
    name: 'McDonalds_cf',
    component: () => import('../../components/McDonalds_cf.vue'),
  },
  {
    path: '/makeupBox_cf',
    name: 'makeupBox_cf',
    component: () => import('../../components/makeupBox_cf.vue'),
  },
  {
    path: '/Outback',
    name: 'Outback',
    component: () => import('../../components/Outback.vue'),
  },
  {
    path: '/Publix',
    name: 'Publix',
    component: () => import('../../components/Publix.vue'),
  },
  {
    path: '/popmart',
    name: 'popmart',
    component: () => import('../../components/popmart.vue'),
  },
  {
    path: '/PaknSave',
    name: 'PaknSave',
    component: () => import('../../components/PaknSave.vue'),
  },
  {
    path: '/Presentkort',
    name: 'Presentkort',
    component: () => import('../../components/Presentkort.vue'),
  },
  {
    path: '/Paypal',
    name: 'Paypal',
    component: () => import('../../components/Paypal.vue'),
  },
  {
    path: '/Shopee',
    name: 'Shopee',
    component: () => import('../../components/Shopee.vue'),
  },
  {
    path: '/Shein',
    name: 'Shein',
    component: () => import('../../components/Shein.vue'),
  },
  {
    path: '/SoftDrink',
    name: 'SoftDrink',
    component: () => import('../../components/SoftDrink.vue'),
  },
  {
    path: '/SamsungS10',
    name: 'SamsungS10',
    component: () => import('../../components/SamsungS10.vue'),
  },
  {
    path: '/SamsClub',
    name: 'SamsClub',
    component: () => import('../../components/SamsClub.vue'),
  },
  {
    path: '/SamsClub_cf',
    name: 'SamsClub_cf',
    component: () => import('../../components/SamsClub_cf.vue'),
  },
  {
    path: '/Subway',
    name: 'Subway',
    component: () => import('../../components/Subway.vue'),
  },
  {
    path: '/Subway_cf',
    name: 'Subway_cf',
    component: () => import('../../components/Subway_cf.vue'),
  },
  {
    path: '/Subway_cf2',
    name: 'Subway_cf2',
    component: () => import('../../components/Subway_cf2.vue'),
  },
  {
    path: '/Subway2',
    name: 'Subway2',
    component: () => import('../../components/Subway2.vue'),
  },
  {
    path: '/Subway3',
    name: 'Subway3',
    component: () => import('../../components/Subway3.vue'),
  },
  {
    path: '/Target',
    name: 'Target',
    component: () => import('../../components/Target.vue'),
  },
  {
    path: '/Target1',
    name: 'Target1',
    component: () => import('../../components/Target1.vue'),
  },
  {
    path: '/Uniqlo',
    name: 'Uniqlo',
    component: () => import('../../components/Uniqlo.vue'),
  },
  {
    path: '/Willys',
    name: 'Willys',
    component: () => import('../../components/Willys.vue'),
  },
  {
    path: '/Kroger',
    name: 'Kroger',
    component: () => import('../../components/Kroger.vue'),
  },
  {
    path: '/Kroger2',
    name: 'Kroger2',
    component: () => import('../../components/Kroger2.vue'),
  },
  {
    path: '/Laundry',
    name: 'Laundry',
    component: () => import('../../components/Laundry.vue'),
  },
  {
    path: '/Mac',
    name: 'Mac',
    component: () => import('../../components/Mac.vue'),
  },
  {
    path: '/MacBook',
    name: 'MacBook',
    component: () => import('../../components/MacBook.vue'),
  },
  {
    path: '/MacBook2',
    name: 'MacBook2',
    component: () => import('../../components/MacBook2.vue'),
  },
  {
    path: '/Markita',
    name: 'Markita',
    component: () => import('../../components/Markita.vue'),
  },
  {
    path: '/Markt',
    name: 'Markt',
    component: () => import('../../components/Markt.vue'),
  },
  {
    path: '/MyDailySurge',
    name: 'MyDailySurge',
    component: () => import('../../components/MyDailySurge.vue'),
  },
  {
    path: '/newbike',
    name: 'newbike',
    component: () => import('../../components/newbike.vue'),
  },
  {
    path: '/nutella',
    name: 'nutella',
    component: () => import('../../components/nutella.vue'),
  },
  {
    path: '/nutella1',
    name: 'nutella1',
    component: () => import('../../components/nutella1.vue'),
  },
  {
    path: '/nutella2',
    name: 'nutella2',
    component: () => import('../../components/nutella2.vue'),
  },
  {
    path: '/walmart',
    name: 'walmart',
    component: () => import('../../components/walmart.vue'),
  },
  {
    path: '/walmart1',
    name: 'walmart1',
    component: () => import('../../components/walmart1.vue'),
  },
  {
    path: '/walmart2',
    name: 'walmart2',
    component: () => import('../../components/walmart2.vue'),
  },
  {
    path: '/walmart3',
    name: 'walmart3',
    component: () => import('../../components/walmart3.vue'),
  },
  {
    path: '/walmart4',
    name: 'walmart4',
    component: () => import('../../components/walmart4.vue'),
  },
  {
    path: '/walmart5',
    name: 'walmart5',
    component: () => import('../../components/walmart5.vue'),
  },
  {
    path: '/walmart6',
    name: 'walmart6',
    component: () => import('../../components/Walmart6.vue'),
  },
  {
    path: '/walmart7',
    name: 'walmart7',
    component: () => import('../../components/Walmart7.vue'),
  },
  {
    path: '/walmart8',
    name: 'walmart8',
    component: () => import('../../components/Walmart8.vue'),
  },
  {
    path: '/walmart9',
    name: 'walmart9',
    component: () => import('../../components/Walmart9.vue'),
  },
  {
    path: '/walmart10',
    name: 'walmart10',
    component: () => import('../../components/Walmart10.vue'),
  },
  {
    path: '/Walmart11',
    name: 'Walmart11',
    component: () => import('../../components/Walmart11.vue'),
  },
  {
    path: '/walmarttime',
    name: 'walmarttime',
    component: () => import('../../components/walmarttime.vue'),
  },
  {
    path: '/General',
    name: 'General(无感知)',
    component: () => import('../../components/General.vue'),
  },
  {
    path: '/General_cf',
    name: 'General_cf(无感知)',
    component: () => import('../../components/General_cf.vue'),
  },
  {
    path: '/Walmart_cf',
    name: 'Walmart_cf',
    component: () => import('../../components/Walmart_cf.vue'),
  },
  {
    path: '/Walmart_cf2',
    name: 'Walmart_cf2',
    component: () => import('../../components/Walmart_cf2.vue'),
  },
  // {
  //   path: '/testcf',
  //   name: 'testcf',
  //   component: () => import('../../components/testcf.vue'),
  // },
  // {
  //   path: '/CashApp13',
  //   name: 'CashApp13',
  //   component: () => import('../../components/CashApp13.vue'),
  // },
]);
